import { CURRENCY_SYMBOL, ROLES } from './constant';
import secureStorage from './encrypt';
import { toast } from 'react-toastify';
import forge from 'node-forge';
import { SKIP_ENCRYPTION_ROUTE_KEYWORDS } from './id/constant';


export const isUserHasAccessPage = (params: { permissionID: string | number, accessType: any, assignUserId?: string | null | undefined }) => {
    let { permissionID, accessType, assignUserId } = params;

    let isAuthorized = false;
    let authUserInfo = secureStorage.getItem('authUserInfo');
    let userDetails = authUserInfo && authUserInfo.user_data;
    if (permissionID) {
        const accessParams = (userDetails && userDetails.feature_access) ? userDetails?.feature_access?.filter((feature: any) => +feature?.assigned_feature_ids === +permissionID) : [];
        if (accessParams && accessParams[0]) {

            let checkEditAccess = accessParams?.filter((feature: any) => ([1, 2].includes(+feature.assigned_role_id) && feature.canEdit) || (assignUserId && [3].includes(+feature.assigned_role_id) && '' + assignUserId === '' + userDetails.id && feature.canEdit) || (![1, 2, 3].includes(+feature.assigned_role_id) && feature.canEdit))
            let checkViewAccess = accessParams?.filter((feature: any) => ([1, 2].includes(+feature.assigned_role_id) && feature.canView) || (assignUserId && [3].includes(+feature.assigned_role_id) && '' + assignUserId === '' + userDetails.id && feature.canView) || (![1, 2, 3].includes(+feature.assigned_role_id) && feature.canView))
            
            if (accessType === 'edit' && checkEditAccess.length) {
                isAuthorized = true;

            }
            else if (accessType === 'view' && checkViewAccess.length && userDetails.assigned_role_ids.indexOf("3") >= 0) {
                isAuthorized = true;
            }
            else if (accessType === 'isVisible') {
                isAuthorized = true;
            }
        }
    }

    return isAuthorized;
}

export const addCurrencyFormatting = (number: any) => {
    number = number ? number.toString().replace(/,/g, '') : 0;
    return CURRENCY_SYMBOL + ' ' + (+number ? (+number).toLocaleString("de-DE") : 0);
}

export const getOrdinal = (n: number) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export const  handleCopyText = (text: string) => {
    if (!text) return;
    navigator.clipboard.writeText(text)
        .then(() => {
            toast.success("Copied!");
        })
    .catch((err) => {
        console.error("Failed to copy: ", err);
    });
}

export const navigatePermssion = (navigate: (path: string) => void) =>{
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const role_id = authUserInfo?.user_data?.assigned_role_ids;
    if(authUserInfo && role_id){
        const roleName = Object.keys(ROLES).find(key => ROLES[key] === role_id);
        console.log('roleName----',roleName);
        switch (roleName) {
            case 'ADMIN':
            case 'SALES_HEAD':
            case 'SALES_MANAGER':
            case 'COLLECTIONS_SALES_AGENT':
                navigate(`/lead-list`)
            break;
            case 'FINANCE_TEAM':
                navigate(`/payment-list`);
            break;
            case 'RECO_TEAM':
                navigate(`/reconciliation-list`);
            break;
        
            default:
                navigate(`/login`);
                break;
        }
    }else{
        navigate(`/login`)
    }


}

export const encryptAesKey = (params: any) => {
    try {
        let {encPubKey, body, URL} = params;
        let symmetricKey = forge.random.getBytesSync(16);
        let iv = forge.random.getBytesSync(16);
        var encryptedReqData : any;
        let encryptedSymmetricKey: any;
        let isBodyLength = false;
        let formObj: any = {};
        let updatedFormData = new FormData();

        if(URL.indexOf('/addDocumentWeb') >= 0 || URL.indexOf('/uploadCsv') >= 0 || URL.indexOf('/uploadAddOnCsv') >= 0 || URL.indexOf('/addInsurancePartner') >= 0 || URL.indexOf('/updateInsurancePartner') >= 0 || URL.indexOf('/addAgencyWebDocument') >= 0 || URL.indexOf('/paymentProofDocs') >= 0 || URL.indexOf('/uploadAndReadDocument') >= 0) {
            for(var pair of body.entries()) 
                {
                    if(pair[0] !== "files"){                        
                        formObj[pair[0]] = pair[1]
                    }else{
                        updatedFormData.append('files', pair[1])
                    }
                }

                // updatedFormData.set('formData', formObj)//storage.encrypt(JSON.stringify(formObj), generateAesKey))

                // body = formObj//{...body, ...updatedFormData};
                isBodyLength = true;
        }else{
            isBodyLength = (body && Object.keys(body)?.length);
            // body = JSON.stringify(body)
        }

        if(isBodyLength){

            let cipher = forge.cipher.createCipher('AES-CBC', symmetricKey);
            cipher.start({iv: iv});
            cipher.update(forge.util.createBuffer(JSON.stringify(body), 'utf8'));
            cipher.finish();
            // encryptedReqData = cipher.output.toHex();
            encryptedReqData = forge.util.encode64(cipher.output.getBytes());

            if(Object.keys(formObj).length){
                updatedFormData.append('formData', encryptedReqData)
                encryptedReqData = body//updatedFormData
                
            }


            const publicKey = forge.pki.publicKeyFromPem(encPubKey);
            encryptedSymmetricKey = publicKey.encrypt(symmetricKey, 'RSA-OAEP');
            encryptedSymmetricKey = forge.util.encode64(encryptedSymmetricKey);

        }

        return {encryptedReqData, iv: forge.util.encode64(iv), symmetricKey: encryptedSymmetricKey};
    } catch (error) {
        throw error;
    }
};

export const decryptResponseData = (encryptedData:any, iv:any, symmetricKey:any) => {
    try{
        const decipher = forge.cipher.createDecipher('AES-CBC', forge.util.decode64(symmetricKey));
        decipher.start({ iv: forge.util.decode64(iv) });
        decipher.update(forge.util.createBuffer(forge.util.decode64(encryptedData), 'raw'));
        decipher.finish();
        return JSON.parse(decipher.output.toString());
    }catch(err){
        throw new Error('Unable to decrypt data');
    }
}

export const encryptRequestData = async (URL:any, headers:any, body:any) => {
    return new Promise(async (resolve)=>{
     
       if (SKIP_ENCRYPTION_ROUTE_KEYWORDS.some(keyword => URL.includes(keyword))) {
            resolve({ body, headers });
            return;
       }

        let encryptedReqData = "";
        let encPubKey = secureStorage.getItem('encryptionPublicKey');

        if(URL.indexOf('/getPublicKey') === -1){

            // body = body && Object.keys(body).length ? JSON.stringify(body) : "";
            let {encryptedReqData, iv, symmetricKey} = encryptAesKey({encPubKey, body, headers, URL});
            headers['isresponseencrypted'] = (typeof headers['isresponseencrypted'] !== 'undefined') ? headers['isresponseencrypted'] : 1;
            headers['encryptedIV'] = iv;
            headers['encryptedSymmetricKey'] = symmetricKey;
            body = {requestData:encryptedReqData};

            if(encryptedReqData instanceof FormData){

                    body = encryptedReqData//{requestData:encryptedReqData};
            }

            //if(encryptedReqData)

            resolve({body, headers, encryptedReqData})
        }else{
            resolve({body, headers, encryptedReqData})
        }
    })
}


